import { Directive, Input, OnDestroy, Signal } from '@angular/core';
import { IndicationConfigDirective } from './indication-config.directive';

/**
 * @description
 * Toggle show | hide templated content according to a specific boolean flag value which
 * is part of a feature's configuration > indication flags collection
 */
@Directive({
  standalone: true,
  selector: '[indFalseConfig]',
  exportAs: 'indFalse'
})
export class IndFalseConfigDirective extends IndicationConfigDirective implements OnDestroy {
  @Input()
  set indFalseConfig(key: string) {
    /**
     * "value" is the name of a specific config (boolean) flag. once received - the flag's value
     * is read and the effect is being triggered to match behavior to the value (show | hide template)
     **/
    this.value$$ = this.fromIndications$$(key, false);
    this.addChangeEffect();
  }

  override value$$: Signal<boolean>;

  constructor() {
    super();
  }
}
